import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { SidenavService } from '../../services/sidenav.service';
import { StandingsService } from '../../services/standings.service';

@Component({
  selector: 'app-stats-scorers',
  templateUrl: './stats-scorers.component.html',
  styleUrls: ['./stats-scorers.component.scss'],
  standalone: false,
})
export class StatsScorersComponent implements OnInit {
  sidenav: MatSidenav;
  scorers: Array<any> = [];
  loading = true;

  constructor(
    private sidenavService: SidenavService,
    private standingsService: StandingsService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  async ngOnInit() {
    await this.loadScorers();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/stats']);
  }

  private async loadScorers() {
    this.loading = true;

    try {
      const response = await this.standingsService.getScorers(50);
      this.scorers = response?.scorers || [];
    } finally {
      this.loading = false;
    }
  }

  getPlayerAge(dateOfBirth?: string): number | null {
    if (!dateOfBirth) {
      return null;
    }

    const birthDate = new Date(dateOfBirth);

    if (Number.isNaN(birthDate.getTime())) {
      return null;
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return age;
  }
}
